import View from './model/view';
import DetailsView from './model/details-view';

export default angular
	.module('mx.shell', [])
	.value('mx.shell.View', View)
	.value('mx.shell.DetailsView', DetailsView)
	.run([
		'mx.app.HttpInterceptorsRegistry',
		'mx.shell.Config',
		'mx.shell.RoutingService',
		'$timeout',
		'$q',
		function (httpInterceptorsRegistry, mxConfig, routingService, $timeout, $q) {
			const restApi = mxConfig.get('restHosts');

			//not found handler
			httpInterceptorsRegistry.register({
				responseError: function (response) {
					if (response.status === 404) {
						let navigateTo404 = true;

						for (let key in restApi) {
							if (restApi.hasOwnProperty(key)) {
								navigateTo404 = response.config.url.indexOf(restApi[key]) === -1;
								if (!navigateTo404) {
									break;
								}
							}
						}
						// Skip navigation to 404 route when api fails
						if (navigateTo404) {
							// TODO: remove timeout workaround after fixed bug in router
							$timeout(function () {
								routingService.go('404');
							}, 10);
						}
					}
					return $q.reject(response);
				},
			});
		},
	]).name;
